import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import {OwnershipTransferPrivateBuyerStep, PopupMessageContent, MessageContent, PopupEnum, ServiceType} from './Constant/Constant';

export const validateTransferAccess = createAsyncThunk('OwnershipTransferPrivateBuyer/validateTransferAccess', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('validateOwnershipTransferAccess', data);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return error;
  }
});

export const submitOwnershipTransfer = createAsyncThunk('OwnershipTransferPrivateBuyer/submitOwnershipTransfer', async (data, thunkAPI) => {
  thunkAPI.dispatch(showAppLoader());
  try {
    const result = await ProviderManager.getProviderData('submitPrivateOwnershipTransfer', data);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return error;
  }
});
export const needsToSignCollaborationApproval = createAsyncThunk(
  'OwnershipTransferPrivateBuyer/needsToSignCollaborationApproval',
  async (data, thunkAPI) => {
    try {
      const result = await ProviderManager.getProviderData('needsToSignCollaboration', [data]);

      return result.Body;
    } catch (error) {
      return error;
    }
  },
);

const initialState = {
  currentStep: OwnershipTransferPrivateBuyerStep.Loading,
  showPopup: false,
  currentPopUp: null,
  currentPopupData: null,
  serviceToTransfer: null,
  orderId: '',
  serviceType: '',
  transferProductName: '',
  transferSubscriberNumber: '',
  selectedBan: '',
  banList: [],
  buyerPersonalData: {
    firstName: '',
    lastName: '',
    email: '',
  },
  buyerAddress: {
    city: '',
    street: '',
    houseNum: '',
    apartmentNum: '',
  },
  failReason: '',
  generalMessage: null,
  collaborationApproval: false,
  needsToSignCollaborationApproval: true,
  simResponsibilities: false,
};

const OwnershipTransferBuyerSlice = createSlice({
  name: 'OwnershipTransferBuyer',
  initialState: initialState,

  reducers: {
    resetState: () => initialState,

    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
      return state;
    },

    setShowPopUp: (state, action) => {
      state.currentPopupData = null;
      state.currentPopUp = null;
      state.showPopup = action.payload;
      return state;
    },
    setCurrentPopUp: (state, action) => {
      state.showPopup = true;
      state.currentPopUp = action.payload.currentPopUp;
      if (action.payload.currentPopupData) {
        state.currentPopupData = action.payload.currentPopupData;
      }

      return state;
    },
    setSelectedPricePlan: (state, action) => {
      state.selectedPricePlan = action.payload;
    },
    setTransferProductData: (state, action) => {
      state.transferSubscriberNumber = action.payload.number;
      state.transferProductName = action.payload.name;
      state.serviceType = action.payload.type;
    },
    setSelectedBan: (state, action) => {
      state.selectedBan = action.payload;
    },
    setCollaborationApproval: (state, action) => {
      state.collaborationApproval = action.payload;
    },
    setBuyerPersonalData: (state, action) => {
      if (action.payload.firstName !== undefined) {
        state.buyerPersonalData.firstName = action.payload.firstName;
      }
      if (action.payload.lastName !== undefined) {
        state.buyerPersonalData.lastName = action.payload.lastName;
      }
      if (action.payload.email !== undefined) {
        state.buyerPersonalData.email = action.payload.email;
      }
    },
    setSimResponsibilities: (state, action) => {
      state.simResponsibilities = action.payload;
    },
    setBuyerAddress: (state, action) => {
      state.buyerAddress.city = action.payload.city;
      state.buyerAddress.street = action.payload.street;
      state.buyerAddress.houseNum = action.payload.houseNum;
      state.buyerAddress.apartmentNum = action.payload.apartment;
      state.buyerAddress.zipCode = action.payload.zipCode;
    },
  },
  extraReducers: {
    [validateTransferAccess.fulfilled]: (state, action) => {
      if (!action.payload?.isAxiosError && !action.payload.errorCode) {
        if (action.payload.success) {
          state.orderId = action.payload.orderId;
          if (action.payload.banList?.length > 0) {
            state.banList = action.payload.banList;
            state.currentStep = OwnershipTransferPrivateBuyerStep.SelectBan;
            return state;
          }
          state.currentStep = OwnershipTransferPrivateBuyerStep.CustomerData;
          return state;
        } else {
          if (action.payload.error == 'InvalidParameters' || action.payload.error == 'AccountNotFound') {
            state.generalMessage = MessageContent.GeneralError;
            state.currentStep = OwnershipTransferPrivateBuyerStep.GeneralMessage;
            return state;
          } else if (action.payload.error == 'HasJetOpenOrder') {
            state.failReason = action.payload.error;
            if (state.serviceType == ServiceType.Cellular) {
              state.currentPopupData = PopupMessageContent.CellularOpenWorkOrder;
            } else {
              state.currentPopupData = PopupMessageContent.OpenWorkOrder;
            }
            state.currentPopUp = PopupEnum.MessagePopup;
            state.showPopup = true;
            return state;
          } else if (action.payload.error == 'AdditionalId') {
            state.failReason = action.payload.error;
            if (state.serviceType == ServiceType.Cellular) {
              state.generalMessage = MessageContent.CellularAdditionalOwnersError;
            } else {
              state.generalMessage = MessageContent.AdditionalOwnersError;
            }
            state.currentStep = OwnershipTransferPrivateBuyerStep.GeneralMessage;
            return state;
          } else if (action.payload.error == 'TechnicianVisit') {
            state.generalMessage = MessageContent.GeneralError;
            state.currentStep = OwnershipTransferPrivateBuyerStep.GeneralMessage;
            return state;
          } else if (action.payload.error == 'SubStatus') {
            state.currentPopupData = PopupMessageContent.CellularSubStatusError;
            state.currentPopUp = PopupEnum.MessagePopup;
            state.showPopup = true;
            return state;
          } else if (action.payload.error == 'CellcomDu') {
            state.currentPopupData = PopupMessageContent.CellularCellcomDuError;
            state.currentPopUp = PopupEnum.MessagePopup;
            state.showPopup = true;
            return state;
          } else if (action.payload.error == 'InvalidNPStatus') {
            state.currentPopupData = PopupMessageContent.CellularNPStatusError;
            state.currentPopUp = PopupEnum.MessagePopup;
            state.showPopup = true;
            return state;
          } else if (action.payload.error == 'Abroad') {
            state.currentPopupData = PopupMessageContent.CellularAbroadError;
            state.currentPopUp = PopupEnum.MessagePopup;
            state.showPopup = true;
            return state;
          } else if (action.payload.error == 'Esim') {
            state.currentPopupData = PopupMessageContent.CellularEsimError;
            state.currentPopUp = PopupEnum.MessagePopup;
            state.showPopup = true;
            return state;
          } else if (action.payload.error == 'SwitchCode') {
            state.currentPopupData = PopupMessageContent.CellularDataPackageError;
            state.currentPopUp = PopupEnum.MessagePopup;
            state.showPopup = true;
            return state;
          } else if (action.payload.error == 'IdNumberError') {
            state.failReason = action.payload.error;
            if (state.serviceType == ServiceType.Cellular) {
              state.generalMessage = MessageContent.MustVisitServiceCenterCellular;
            } else {
              state.generalMessage = MessageContent.MustVisitServiceCenter;
            }
            state.currentStep = OwnershipTransferPrivateBuyerStep.GeneralMessage;
            return state;
          }

          // else if (action.payload.error == 'FutureAbroad') {
          //   state.generalMessage = MessageContent.FutureAbroadError;
          //   state.currentStep = OwnershipTransferPrivateBuyerStep.GeneralMessage;
          //   return state;
          // }
          else {
            state.generalMessage = MessageContent.GeneralError;
            state.currentStep = OwnershipTransferPrivateBuyerStep.GeneralMessage;
            return state;
          }
        }
      } else {
        state.generalMessage = MessageContent.GeneralError;
        state.currentStep = OwnershipTransferPrivateBuyerStep.GeneralMessage;
        return state;
      }
    },
    [submitOwnershipTransfer.fulfilled]: (state, action) => {
      if (!action.payload?.isAxiosError && !action.payload.errorCode) {
        if (action.payload.success) {
          if (state.serviceType == ServiceType.Cellular) {
            state.generalMessage = MessageContent.SuccessPageCellular;
          } else {
            if (action.payload.hasPassword === true) {
              state.generalMessage = MessageContent.SuccessPageTv;
            } else {
              state.generalMessage = MessageContent.SuccessPageStationary;
            }
          }
          state.currentStep = OwnershipTransferPrivateBuyerStep.GeneralMessage;
          return state;
        } else {
          if (action.payload.workOrder) {
            state.generalMessage = MessageContent.WorkOrder;
          } else {
            state.generalMessage = MessageContent.GeneralError;
          }
          state.currentStep = OwnershipTransferPrivateBuyerStep.GeneralMessage;
          return state;
        }
      } else {
        state.generalMessage = MessageContent.GeneralError;
        state.currentStep = OwnershipTransferPrivateBuyerStep.GeneralMessage;
        return state;
      }
    },
    [needsToSignCollaborationApproval.fulfilled]: (state, action) => {
      if (!action.payload?.isAxiosError && !action.payload.errorCode) {
        state.needsToSignCollaborationApproval = action.payload;
      }
    },
  },
});

export const {
  resetState,
  setCurrentStep,
  setShowPopUp,
  setCurrentPopUp,
  setSelectedPricePlan,
  setTransferProductData,
  setSelectedBan,
  setCollaborationApproval,
  setBuyerPersonalData,
  setBuyerAddress,
  setSimResponsibilities,
} = OwnershipTransferBuyerSlice.actions;

export default OwnershipTransferBuyerSlice.reducer;
